angular.module('rjmNg.directives').directive "filterSets", [
  () ->
    restrict: "E"
    templateUrl: "settings/directive.filterSets.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    controller: [
      "$routeParams"
      "$scope"
      "$q"
      "$location"
      "filterSetsPath"
      "FilterSets"
      "StructureCache"
      "filterConstants"
      "dependencyEnums"
      "errorConstants"
      "notification"
      "logger"
      "app"
      (
        $routeParams
        $scope
        $q
        $location
        filterSetsPath
        FilterSets
        StructureCache
        filterConstants
        dependencyEnums
        errorConstants
        notification
        logger
        app
      ) ->

        view = @
        view.loading = true
        view.headingText = ""
        view.confirmButtonText = ""

        view.showFilterSetsList = false
        view.showFilterSetEditor = false
        view.showFilterSetCloner = false
        view.updateFilterSet = false
        view.modificationAction = null
        view.editedFilterSet = null
        view.readyToSave = false

        view.isAdmin = app.isAdminUser()
        view.supportEmail = app.getSupportEmail()
        view.clientId = $routeParams.clientId
        notificationTimeout = 15
        view.notificationTemplate = 'template.notification.supportLink.html'

        view.dependencyPromises = {}
        view.showDependencyResolver = false
        view.depReadOnly = false
        view.depResourceType = dependencyEnums.RESOURCE_TYPES.FILTER_SET
        view.depResourceNames = {}
        view.depConfirmMsg = "Delete filter set and metrics?"

        _handleSuccessResponse = (response) ->
          [view.structure, view.filterSets] = response
          view.tables = []
          view.tables.push table for id, table of view.structure.tables
          view.tableHasFilterSetMap = FilterSets.buildTableHasFilterSetMap(view.tables, view.filterSets)

        _loadFiltersAndStructure = () ->
          $q.all([
            StructureCache.getStructure(),
            FilterSets.get(view.clientId)
          ]).then(
            (response) ->
              _handleSuccessResponse(response)
              [action, filterSetId] = filterSetsPath.parsePath($location.path())

              if view.isAdmin
                # If admin then handle path
                if filterSetId
                  matchFilterSet = null
                  for filter in view.filterSets
                    if filter.id is filterSetId
                      matchFilterSet = filter
                  if matchFilterSet
                    view.editedFilterSet = matchFilterSet
                    view.modificationAction = action
                  else
                    _showError("There is no Filter Set with id equals <span class='rj-label--error'>#{filterSetId}</span>.")
                    view.editedFilterSet = null
                    view.modificationAction = filterConstants.MODIFICATION_ACTIONS.SHOWLIST
                    filterSetsPath.updatePath(view.modificationAction)
                else
                  view.editedFilterSet = null
                  view.modificationAction = if action? then action else filterConstants.MODIFICATION_ACTIONS.SHOWLIST
                  unless action?
                    filterSetsPath.updatePath(view.modificationAction)
              else
                # If not admin then show filter sets list page
                view.editedFilterSet = null
                view.modificationAction = filterConstants.MODIFICATION_ACTIONS.SHOWLIST
                filterSetsPath.updatePath(view.modificationAction)
              view.loading = false
            , (error) ->
              _showError(errorConstants.SERVER_ERROR_MESSAGE)
              view.loading = false
          )

        _updateFiltersAndStructure = () ->
          view.loading = true
          $q.all([
            StructureCache.getStructure(),
            FilterSets.get(view.clientId)
          ]).then(
            (response) ->
              _handleSuccessResponse(response)
              view.loading = false
            , (error) ->
              _showError(errorConstants.SERVER_ERROR_MESSAGE)
              view.loading = false
          )

        _showError = (text) ->
          notification.error("Server Error", text, "filterSets", null, notificationTimeout)

        _showSuccess = (text) ->
          notification.success("success", text, "filterSets", null, notificationTimeout)

        _filterSetsChanged = (context = null) ->
          switch view.modificationAction
            when filterConstants.MODIFICATION_ACTIONS.CREATE then notificationText = "Filter Set '#{context.replace( /(<([^>]+)>)/ig, '')}' has been successfully created!"
            when filterConstants.MODIFICATION_ACTIONS.UPDATE then notificationText = "Filter Set '#{context.replace( /(<([^>]+)>)/ig, '')}' has been successfully updated!"
            when filterConstants.MODIFICATION_ACTIONS.DELETE then notificationText = "Filter Set has been successfully deleted!"
            when filterConstants.MODIFICATION_ACTIONS.CLONE then notificationText = "Filter Set '#{context.replace( /(<([^>]+)>)/ig, '')}' has been successfully cloned!"
          view.openFilterSetsListPage()
          _showSuccess(notificationText)
          _updateFiltersAndStructure()

        view.openCreateFilterSetPage = () ->
          view.modificationAction = filterConstants.MODIFICATION_ACTIONS.CREATE
          filterSetsPath.updatePath(view.modificationAction)

        view.openFilterSetsListPage = () ->
          view.editedFilterSet = null
          view.modificationAction = filterConstants.MODIFICATION_ACTIONS.SHOWLIST
          filterSetsPath.updatePath(view.modificationAction)

        view.openUpdateFilterSetPage = (filterSet) ->
          view.editedFilterSet = filterSet
          view.modificationAction = filterConstants.MODIFICATION_ACTIONS.UPDATE
          filterSetsPath.updatePath(view.modificationAction, filterSet.id)

        view.openCloneFilterSetPage = (filterSet) ->
          view.editedFilterSet = filterSet
          view.modificationAction = filterConstants.MODIFICATION_ACTIONS.CLONE
          filterSetsPath.updatePath(view.modificationAction, filterSet.id)

        view.modifyFilterSet = () ->
          $scope.$broadcast 'modifyFilterSet'

        view.cloneFilterSet = () ->
          $scope.$broadcast 'cloneFilterSet'

        view.deleteFilterSet = () ->
          view.openDeleteModal(view.editedFilterSet.id)

        $scope.$on "filterSetsChanged", (event, context) ->
          _filterSetsChanged(context)

        $scope.$on "openUpdateFilterSetPage", (event, filterSet) ->
          view.openUpdateFilterSetPage(filterSet)

        $scope.$on "openCloneFilterSetPage", (event, filterSet) ->
          view.openCloneFilterSetPage(filterSet)

        $scope.$on "deleteFilterSet", (event, filterSetId) ->
          view.openDeleteModal(filterSetId)

        view.openDeleteModal = (filterSetId) ->
          view.dependencyPromises = {}
          view.depResourceNames = {}
          filterSetName = fs.name for fs in view.filterSets when fs.id is filterSetId
          view.dependencyPromises[filterSetId] = FilterSets.dependents(view.clientId, filterSetId)
          view.depResourceNames[filterSetId] =
              name: filterSetName
          view.showDependencyResolver = true

        view.confirmDeleteCallback = (choices) ->
          deletePromises = []
          for id, value of choices when value.selected
            deletePromises.push(FilterSets.delete(view.clientId, id))
          if deletePromises.length > 0
            view.loading = true
            view.modificationAction = filterConstants.MODIFICATION_ACTIONS.DELETE
            $q.all(deletePromises).then(
              (response) ->
                logger.log('Filters Page Usage', 'Delete', 1, 'delete')
                _filterSetsChanged()
              ,
              (error) ->
                view.loading = false
                _showError(errorConstants.SERVER_ERROR_MESSAGE)
            )

        view.modificationActionChanged = () ->
          switch view.modificationAction
            when filterConstants.MODIFICATION_ACTIONS.CREATE
              view.showFilterSetsList = false
              view.showFilterSetEditor = true
              view.showFilterSetCloner = false
              view.updateFilterSet = false
              view.headingText = " Create Filter Set"
              view.confirmButtonText = "Save"
            when filterConstants.MODIFICATION_ACTIONS.UPDATE
              view.showFilterSetsList = false
              view.showFilterSetEditor = true
              view.showFilterSetCloner = false
              view.updateFilterSet = true
              view.headingText = " Edit Filter Set"
              view.confirmButtonText = "Save Changes"
            when filterConstants.MODIFICATION_ACTIONS.CLONE
              view.showFilterSetsList = false
              view.showFilterSetEditor = false
              view.showFilterSetCloner = true
              view.updateFilterSet = false
              view.headingText = " Clone Filter Set"
              view.confirmButtonText = "Clone"
            when filterConstants.MODIFICATION_ACTIONS.SHOWLIST
              view.showFilterSetsList = true
              view.showFilterSetEditor = false
              view.showFilterSetCloner = false
              view.updateFilterSet = false
              view.headingText = ""
              view.confirmButtonText = "Create New Filter Set"

        @$onInit = () ->
          _loadFiltersAndStructure()
          notification.clear('filterSets')
          notification.info(
            null,
            "Filter Sets help you filter multiple metrics and columns in the same way (e.g. filtering out test orders). <span class='rj-icon--help rj-tooltip'> <div class='rj-tooltip__popup rj-tooltip__popup--wider'> Help Center Article: <a class='rj-tooltip__popup-link' href='https://docs.magento.com/mbi/data-user/reports/ess-manage-data-filters.html' target='_blank'> Creating filter sets for metrics </a> </div> </span>",
            "filterSets",
            {
              dismissable: true,
              bindHtml: true
            }
          )

        view
    ]
    link: (scope, element, attributes, view) ->

      scope.$watch 'view.modificationAction', view.modificationActionChanged, true
]
